<template>
  <div class="col">
    <div class="row">
      <div class="col web5-content-subheader"></div>
    </div>
    <div class="row web5-headline">
      <div class="col">
        <p>Kennwort ändern<br /></p>
      </div>
    </div>

    <div>
        <p v-if="isError" class="alert">Die Kennwörter stimmen nicht überein. Bitte korrigieren Sie Ihre Kennwörter</p>
    </div>

    <div class="row g-0 web5-login-content">
      <div class="col max__width">
        <form @submit.prevent="changePassword()" class="form-signin">
          <div class="class=input-group space_surround">
            <input
              :type="passwordType"
              id="userPassword"
              class="form-control"
              placeholder="Password"
              autocomplete="current-password"
              spellcheck="false"
              autocorrect="off"
              autocapitalize="off"
              v-model="password"
            />
          </div>
          <div class="class=input-group space_surround">
            <input
              :type="passwordType"
              id="userPasswordCheck"
              class="form-control"
              placeholder="Password"
              autocomplete="current-password"
              spellcheck="false"
              autocorrect="off"
              autocapitalize="off"
              v-model="passwordCheck"
            />
          </div>
          <button class="btn btn-primary eFj-login-button space_surround">Ändern</button>
        </form>
      </div>
      
    </div>
  </div>
</template>

<script language="ts">
import { useRouter} from "vue-router"
import { reactive, ref, toRefs } from "vue";
import { useStore } from "vuex";
import { apiPost } from "@/services/api/fetchapi";
import router from "@/router/index";

//PasswordEmailConfirm
export default {
  components: {},
  name: "ChangePassword",
  inheritAttrs: false,  
  setup(props,context) {

    const isError = ref(false);
    const loginInformation = reactive({
      password: "",
      passwordCheck: ""
    });
    useRouter

    const passwordType = ref("password");
    const passwortIcon = ref("img/icons/eye-slash.svg");
    const store = new useStore();

    //userId: store.getters["userstore/getUser"]
    async function tryChangePassword() {

        isError.value = false;
        if ( loginInformation.password == undefined || loginInformation.password == null || loginInformation.password == isNaN) {
          isError.value = true;
          return;
        }


        if ( loginInformation.password.length < 3 || loginInformation.password !== loginInformation.passwordCheck ) {
          isError.value = true;
          return;
        }

       const temp = await apiPost("ComponentView/changePassword", {
         benutzerId: store.getters["userstore/getUser"],
         kennwort: loginInformation.password
      });

      if ( temp.userId.indexOf("00000000-0000-0000-0000-000000000000") < 0) {
          router.push({name: "Home"});
      }

    }

    function togglePassword() {

      if (passwordType.value === "password") {
        passwordType.value = "text";
        //passwortIcon.value = "img/icons/visibility-24px.svg";
        passwortIcon.value = "img/icons/eye.svg";
      } else {
        passwordType.value = "password";
        //passwortIcon.value = "img/icons/visibility_off-24px.svg";
        passwortIcon.value = "img/icons/eye-slash.svg";
      }
    }

    return {
      ...toRefs(
        loginInformation,        
        loginInformation.password,
        loginInformation.passwordCheck
      ),
      changePassword: tryChangePassword,
      passwordType,
      togglePassword,
      passwortIcon,
      isError
    };
  }
};
</script>

<style scoped lang="scss">

.alert {
  color: red;
  font-size: bold;
}

.align__center {
  text-align: center !important;
}

.max__width {  
  max-width: 400px !important;
  width: 400px !important;
  
}

.space_surround {  
  margin-bottom: 20px;
  margin-top: 20px;
}

.web5-headline {
  padding-left: 5vw;
  padding-top: 1vh;
  text-align: center;
  color: rgb(0, 86, 150);
  font-size: 1.9rem;
  font-weight: bold;
  min-height: 16vh;
  height: 16vh;
}

.web5-login-content {
  padding-left: 5vw;
  padding-right: 5vw;
  text-align: center;
  justify-content: center;
 
}

.web5-login-button {
  background-image: linear-gradient(90deg, rgb(0, 86, 150), rgb(14, 161, 196));
}

.login__container--password {
  border: #ced4da 1px solid;
  border-radius: 4px;
  
}

.login__input--password {
  border: none !important;
  display: inline-block;
  
}

.password-image {
  width: 10vw;
  margin-top: -0.125rem;
  vertical-align: -webkit-baseline-middle;
  background: transparent;
  color: black;
  display: inline-block;
}

.web5-login-link-section {
  padding-top: 5vh;
  padding-left: 5vw;
  text-align: center;
  min-height: 14vh;
  height: 14h;
}

.form-control:focus {
  box-shadow: none;
}

.not-active {
  pointer-events: none;
  cursor: default;
}

a {
  padding: 0px;
  margin: 0px;
  padding-bottom: 2vh;
}

a:link {
  color: black;
}

/* visited link */
a:visited {
  color: black;
}

/* mouse over link */
a:hover {
  color: rgb(175, 8, 8);
}

/* selected link */
a:active {
  color: black;
}

.form-signin .btn {
  font-size: 80%;
  color: white;
  border-radius: 0.4rem;
  letter-spacing: 0.4rem;
  font-weight: bold;
  transition: all 0.2s;
  width: 100%;
}
</style>
